/*! Copyright (c) 2021-present the Curry authors. All rights reserved. MIT license. */
var n = function n(_n) {
  var t = function t() {
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    return e.length >= _n.length ? _n.apply(void 0, e) : t.bind.apply(t, [null].concat(e));
  };

  return t;
};

export { n as curry };